module.exports = __webpack_public_path__ + "static/media/slide-3.181246d0.jpg";